(function () {
  window.FDS_SEARCH_EXCLUDED_PRODUCT_HANDLES = window.FDS_SEARCH_EXCLUDED_PRODUCT_HANDLES || [];

  function getHandleFromProduct(product) {
    if (!product) return '';
    if (product.handle) return String(product.handle);
    var url = product.url || '';
    var match = url.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  window.fdsIsProductExcludedFromSearch = function (productOrUrl) {
    var handles = window.FDS_SEARCH_EXCLUDED_PRODUCT_HANDLES || [];
    if (!handles.length) return false;

    var handle = '';
    if (typeof productOrUrl === 'string') {
      var match = productOrUrl.match(/\/products\/([^/?#]+)/);
      handle = match ? match[1] : productOrUrl;
    } else {
      handle = getHandleFromProduct(productOrUrl);
    }

    return handle !== '' && handles.indexOf(handle) !== -1;
  };
})();
